import React from 'react';
import { InputNumber } from 'antd/lib/index';
import moment from 'moment/moment';
import { isNumber } from 'lodash';
import styled from 'styled-components';

import { decomposeMillis } from '../../utils/common';

const isUnitNumber = (unit) => {
  const values = Object.values(unit);
  return values.every((value) => isNumber(value));
};

const StyledDecomposedMillisPicker = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;

  .input-number-container {
    display: flex;
    padding: 0 2px;
  }

  .input-number-label {
    align-self: center;
    min-width: 68px;
  }
`;

const DecomposedMillisPicker = ({ inputClassName, style, value, onChange }) => {
  const { days, hours, minutes, seconds } = decomposeMillis(value);

  const onChangeLocal = (unit) => {
    if (!isUnitNumber(unit)) {
      return;
    }

    onChange(moment.duration({ days, hours, minutes, seconds, ...unit }).valueOf());
  };

  return (
    <StyledDecomposedMillisPicker style={{ ...style }}>
      <div className="input-number-container">
        <div className="input-number-label">Days:</div>
        <InputNumber
          defaultValue={days}
          min={0}
          max={999}
          value={days}
          className={inputClassName}
          onChange={(v) => onChangeLocal({ days: v })}
        />
      </div>
      <div className="input-number-container">
        <div className="input-number-label">Hours:</div>
        <InputNumber
          defaultValue={hours}
          min={0}
          max={23}
          value={hours}
          className={inputClassName}
          onChange={(v) => onChangeLocal({ hours: v })}
        />
      </div>
      <div className="input-number-container">
        <div className="input-number-label">Minutes:</div>
        <InputNumber
          defaultValue={minutes}
          min={0}
          max={59}
          value={minutes}
          className={inputClassName}
          onChange={(v) => onChangeLocal({ minutes: v })}
        />
      </div>
      <div className="input-number-container">
        <div className="input-number-label">Seconds:</div>
        <InputNumber
          defaultValue={seconds}
          min={0}
          max={59}
          value={seconds}
          className={inputClassName}
          onChange={(v) => onChangeLocal({ seconds: v })}
        />
      </div>
    </StyledDecomposedMillisPicker>
  );
};

export default DecomposedMillisPicker;
